import { FileReferenceType } from "./ResourceReference";

export const MAX_FILE_SIZE = 1024 * 1024 * 50;

export type FileReference = {
    id:string,
    type:FileReferenceType
}

export function fileReferenceToEntityId(ref:FileReference):string {
    return ref.type.toLowerCase() + '_' + ref.id;
}

export type FileRecord = {
    
    // Used to identify the file internally. Unique amongst all file records on site
    privateFileName:string;

    // Name of the file when uploaded
    publicFileName:string;

    sizeBytes:number;
   
    created:Date;

    reference:FileReference
}